import { HelpMessage } from 'utils/constants'
import DescriptionFormItem from 'components/CIMSFormItem/common/DescriptionFormItem'
import NameFormItem from 'components/CIMSFormItem/common/NameFormItem'

export const EditOrganizationModalBody: React.FC = () => {
  return (
    <>
      <NameFormItem help={HelpMessage.DesignSubmittals.Organizations.Name} />
      <DescriptionFormItem entityName="Organization" />
    </>
  )
}

export interface EditOrganizationModalValues {
  name: string
  description?: string | null
}
